import { Component, Input } from "@angular/core";

@Component({
  selector: "app-select-profile-dropdown",
  templateUrl: "./select-profile-dropdown.component.html",
  styleUrls: ["./select-profile-dropdown.component.scss"],
})
export class SelectProfileDropdownComponent {
  @Input() public selectedOptionLabel: string = "Select Option";
  public showDropdown = false;

  public toggleDropdown(): void {
    this.showDropdown = !this.showDropdown;
  }
}
